import React from "react";
import { motion } from "framer-motion";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";

const contactItems = [
  {
    label: "Email",
    value: "iamsinghshubhamm@gmail.com",
    href: "mailto:iamsinghshubhamm@gmail.com",
    icon: <HiOutlineMail />,
  },
  {
    label: "LinkedIn",
    value: "iamsinghshubhamm",
    href: "https://www.linkedin.com/in/iamsinghshubhamm/",
    icon: <BsLinkedin />,
  },
  {
    label: "GitHub",
    value: "iamsinghshubhamm",
    href: "https://github.com/iamsinghshubhamm",
    icon: <BsGithub />,
  },
];

const Contact = () => {
  return (
    <section name="contact" className="section-frame pb-20">
      <div className="grid gap-12 rounded-[2rem] border border-white/10 px-6 py-10 sm:px-8 md:px-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:py-14">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7 }}
        >
          <p className="section-kicker">Contact</p>
          <h2 className="section-title mt-6 max-w-xl">
            Have a commerce or payments problem worth solving?
          </h2>
          <p className="section-copy mt-8 text-slate-300">
            I&apos;m open to full-time roles, contract work, and serious product
            collaborations — especially anything involving payments, order
            systems, or reliability. Reach out directly, or use the email button
            in the bottom-right corner.
          </p>

          <div className="mt-10 space-y-5 border-t border-white/10 pt-8">
            {contactItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target={item.label === "Email" ? undefined : "_blank"}
                rel={item.label === "Email" ? undefined : "noreferrer"}
                className="flex items-center gap-4 text-slate-300 transition hover:text-white"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/12 text-lg text-[#f59e0b]">
                  {item.icon}
                </span>
                <span>
                  <span className="block text-xs uppercase tracking-[0.24em] text-slate-500">
                    {item.label}
                  </span>
                  <span className="mt-1 block text-sm sm:text-base">
                    {item.value}
                  </span>
                </span>
              </a>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.75, delay: 0.08 }}
          className="surface-outline overflow-hidden rounded-[2rem]"
        >
          <div className="border-b border-white/10 bg-[radial-gradient(circle_at_top_right,rgba(34,211,238,0.16),transparent_44%),linear-gradient(180deg,rgba(15,23,42,0.92),rgba(8,17,31,0.82))] p-6 sm:p-8">
            <p className="text-xs uppercase tracking-[0.28em] text-[#f59e0b]">
              Availability
            </p>
            <h3 className="mt-4 font-['Sora'] text-3xl leading-tight text-white">
              Currently building at Easybiznus — open to the right next thing.
            </h3>
            <p className="mt-4 max-w-lg text-sm leading-7 text-slate-300 sm:text-base">
              I reply quickly to a clear brief. The more context you share about
              the problem and the stack, the faster I can tell you whether I&apos;m
              the right fit.
            </p>
          </div>

          <div className="grid gap-6 p-6 sm:p-8 sm:grid-cols-2">
            <div className="rounded-[1.6rem] border border-white/10 bg-[#050b14]/55 p-5">
              <p className="text-xs uppercase tracking-[0.22em] text-slate-500">
                Best for
              </p>
              <p className="mt-3 text-base leading-7 text-slate-200">
                Full-time roles, contract engagements, and product collaboration
                in commerce, payments, or fintech.
              </p>
            </div>
            <div className="rounded-[1.6rem] border border-white/10 bg-[#050b14]/55 p-5">
              <p className="text-xs uppercase tracking-[0.22em] text-slate-500">
                Strongest in
              </p>
              <p className="mt-3 text-base leading-7 text-slate-200">
                Payment flows, multi-vendor orders, webhook reliability, and
                full-stack delivery on React and Node.
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      <p className="mt-8 text-center text-xs uppercase tracking-[0.26em] text-slate-500">
        Designed and developed by Shubham
      </p>
    </section>
  );
};

export default Contact;
